/**
 * OpentokRecording VideoTrack implementation.
 *
 * @copyright Realeyes OU. All rights reserved.
 */

import MediaTrackType from '../recording/MediaTrackType';

/**
 * @implements {IVideoTrack}
 */
export default class VideoTrack {
    /**
     * @param {HTMLVideoElement} video Video element
     * @param {number} width Video width
     * @param {number} height Video height
     * @param {IDevice} device Video device
     */
    constructor(video, width, height, device) {
        this.video = video;
        this.width = width;
        this.height = height;
        this.device = device;

        this.workCanv = document.createElement('canvas');
        this.workCanv.width = this.width;
        this.workCanv.height = this.height;
        this.workCtx = this.workCanv.getContext('2d');
    }

    /**
     * @return {Promise.<{ width: number, height: number, bytes: Array }>} // todo: it should be special type img
     */
    getImage() {
        return new Promise((resolve, reject) => {
            try {
                this.workCtx.drawImage(this.video, 0, 0);
                const img = this.workCtx.getImageData(0, 0, this.getWidth(), this.getHeight()).data.buffer;
                const result = {
                    width: this.getWidth(),
                    height: this.getHeight(),
                    bytes: img,
                };
                resolve(result);
            } catch (err) {
                reject(`Something went wrong at getImage method. Err: ${err}`);
            }
        });
    }

    /**
     * @return {IDevice}
     */
    getDevice() {
        return this.device;
    }

    /**
     * @return {number}
     */
    getWidth() {
        return this.width;
    }

    /**
     * @return {number}
     */
    getHeight() {
        return this.height;
    }

    /**
     * @return {string}
     */
    getType() {
        return MediaTrackType.VIDEO;
    }

    /**
     * releases resources
     * @return {Promise}
     */
    dispose() {
        if (this.video !== null) {
            this.video.remove();
            this.video = null;
            this.workCanv.remove();
            this.workCanv = null;
        }

        return Promise.resolve();
    }
}
